var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m64 5.553a58.447 58.447 0 1 0 58.447 58.447 58.514 58.514 0 0 0 -58.447-58.447zm0 113.394a54.947 54.947 0 1 1 54.947-54.947 55.009 55.009 0 0 1 -54.947 54.947z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.64 38.52h-59.28a6.758 6.758 0 0 0 -6.75 6.75v37.46a6.767 6.767 0 0 0 6.75 6.75h59.28a6.767 6.767 0 0 0 6.75-6.75v-37.46a6.758 6.758 0 0 0 -6.75-6.75zm3.123 45.064-18.526-17.284 18.653-14.538c-.054 32.792.118 30.923-.127 31.822zm-32.763-10.621-32.886-25.636v-2.054a3.253 3.253 0 0 1 3.25-3.25h59.272a3.253 3.253 0 0 1 3.25 3.25v2.054zm-32.89-21.2 18.653 14.537-18.526 17.284c-.245-.901-.073.946-.127-31.822zm2.742 34.169 18.707-17.45 10.365 8.08a1.752 1.752 0 0 0 2.152 0l10.365-8.08 18.707 17.449c-.482.076-59.881.069-60.296 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEMail);
export default __webpack_public_path__ + "static/media/e-mail.2ef0c3b5db8af5c4be70b57e8cd637a5.svg";
export { ForwardRef as ReactComponent };